//export const URL = `http://localhost:8000/api/`;
export const URL = `https://pfahomologacaoapi.rehagro.com.br/api/`;
export const HML = `https://pfahomologacao.com.br`;
export const URLBI = `https://pfabi.rehagro.com.br/api/`;
